import { createSlice } from "@reduxjs/toolkit";

const permissionsSlice = createSlice({
  name: 'permissions',
  initialState: {
    roles: null,
    currentRole: null,
    attributes: [],
    subjects: {},
    errors: {}
  },
  reducers: {
    init: (state, action) => {
      return { ...state, ...action.payload }
    },
    addUserRole: (state, action) => {
      const role = action.payload
      state.roles = { ...state.roles, [role.id]: role }
    },
    updateUserRoles: (state, action) => {
      state.roles = { ...action.payload }
    },
    updatePermissionSubject: (state, action) => {
      const subject = action.payload
      state.subjects = { ...state.subjects, [subject.id]: subject }
    },
    updateCurrentRole: (state, action) => {
      state.currentRole = action.payload
    },
    updateErrors: (state, action) => {
      state.errors = action.payload
    }
  }
})

export const { init, updateUserRoles, updatePermissionSubjects, addUserRole, updateCurrentRole, updateErrors } = permissionsSlice.actions
export default permissionsSlice.reducer